import { Check } from 'lucide-react'
import { cn } from '@teach/ui'
import { useMessages } from '@/i18n'
import { messages } from './messages'
import type { MethodOption, PaymentMethod } from './lib/paymentMethods'

interface Props {
  methods: MethodOption[]
  value: PaymentMethod | null
  onChange: (id: PaymentMethod) => void
}

/**
 * Выбор способа оплаты: крупные скруглённые плитки без рамок. Выбранная залита
 * фирменным цветом и отмечена галочкой; цена способа читается отдельной строкой,
 * а не «через тире» в названии.
 */
export const MethodTiles = ({ methods, value, onChange }: Props) => {
  const m = useMessages(messages)
  return (
    <div role="radiogroup" aria-label={m.paymentMethod} className="grid gap-3 sm:grid-cols-2">
      {methods.map(({ id, label, price, icon: Icon }) => {
        const selected = value === id
        return (
          <button
            key={id}
            type="button"
            role="radio"
            aria-checked={selected}
            aria-label={`${label} — ${price}`}
            onClick={() => onChange(id)}
            className={cn(
              'relative flex flex-col items-start gap-4 rounded-2xl p-5 text-left outline-none transition-colors focus-visible:ring-2 focus-visible:ring-ring',
              selected ? 'bg-brand/15' : 'bg-background/60 hover:bg-background/80',
            )}
          >
            <span
              className={cn(
                'flex size-10 items-center justify-center rounded-full',
                selected ? 'bg-brand text-brand-foreground' : 'bg-foreground/10',
              )}
            >
              <Icon className="size-5" />
            </span>
            <span className="space-y-0.5">
              <span className="block text-sm text-muted-foreground">{label}</span>
              <span className="block text-2xl font-bold">{price}</span>
            </span>
            {selected ? <Check className="absolute right-4 top-4 size-5 text-brand" /> : null}
          </button>
        )
      })}
    </div>
  )
}
